import { NotFound } from '@/components/pages/Errors/NotFound'
import { Page } from '@/core/architecture'

import { StoreCartDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreCartDetail Page
 * Implemented as a practical sample.
 */
export const StoreCartDetail: Page = () => {
  const { state, actions } = useViewModel()

  if (!state.loading && !state.cart) {
    return <NotFound useNextRouter={false} />
  }

  return <StoreCartDetailTemplate state={state} {...actions} />
}
